import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../event-centre-dialog.action';
import { EventCentreDialogState } from '../event-centre-dialog.state';
import { determineUnread } from '../function/determine-unread.function';
import { filterItems } from '../function/filter-items.function';

import { UpdateItems } from './update-items.action';

export function updateItemsReducer(
    state: EventCentreDialogState,
    action: PayloadAction<ActionType, UpdateItems>,
): EventCentreDialogState {
    try {
        let nextSeenItems = state.seenItems ?? [];
        const nextItems = state.items.map((e) => {
            if (
                action.payload.items.find(
                    (i) => i.eventCentreItemId === e.eventCentreItemId,
                ) == null
            ) {
                return e;
            }
            if (action.payload.patch.read !== true) {
                nextSeenItems = nextSeenItems.filter(
                    (ee) => ee !== e.eventCentreItemId,
                );
            }
            return {
                ...e,
                read: action.payload.patch.read,
                deleted: action.payload.patch.delete,
            };
        });

        const nextCategories = determineUnread(state.categories, nextItems);

        const nextFilt = filterItems({
            items: nextItems,
            categoryId: state.categoryId,
            filterOpts: state.filterOpts,
            categories: state.categories,
            orderBy: state.orderBy,
            retainAsUnreadForUnreadCategory: action.payload.items.map(
                (e) => e.eventCentreItemId,
            ),
        });

        return {
            ...state,
            categories: nextCategories,
            items: nextItems,
            filteredItems: nextFilt,
            seenItems: nextSeenItems,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
